import React from "react";

type LoaderProps = {
  className?: String;
};

const Loader = ({ className }: LoaderProps) => {
  return (
    <span className={`loading loading-ring loading-lg ${className}`}></span>
  );
};

export default Loader;
